import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach Authorization header if token present in localStorage (fallback)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ff_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_00b1909f-6fb7-42fa-8b76-01f6b56dc459/artifacts/2n6ipu2x_Fine_Food_Logo_FineFoods_Couleur_Blanc.jpg";

// Convert a relative /api/... or storage path URL to an absolute URL pointing at the backend.
export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

export const COMPANY = {
  name: "FineFood Primeur",
  address: "4 C Rue de la Coupe Gordon-Bennett",
  postal: "1219 Le Lignon",
  city: "Genève",
  phone: "078 704 37 23",
  email: "admin@finefoodprimeur.ch",
};
